import React from 'react';

import {
	FlexContainer,
	Avatar,
	Title,
	AttributeName,
	AttributeValue,
	LinkedIssueCard,
} from './styled.tsx';

export const TitleSkeleton = (): React.JSX.Element => (
	<FlexContainer marginBottom={16}>
		<Avatar />
		<Title />
	</FlexContainer>
);

const AttributesListItem = () => (
	<FlexContainer>
		<AttributeName />
		<AttributeValue />
	</FlexContainer>
);

export const AttributesListSkeleton = (): React.JSX.Element => (
	<>
		<AttributesListItem />
		<AttributesListItem />
		<AttributesListItem />
		<AttributesListItem />
	</>
);

export const LinkedIssuesSkeleton = (): React.JSX.Element => (
	<div>
		<LinkedIssueCard />
		<LinkedIssueCard />
	</div>
);
